import { Icon, IconSize } from '@/components/Icon';
import ClientsBrandsSidebar from '@/views/Dashboard/Clients/ClientsBrandsSidebar.vue';
import { ImageView, ImageSize } from '@/components/ImageView';
import FilterToggler from '@/components/Filters/FilterToggler.vue';
import SlotTabs from '@/components/Tabs/SlotTabs.vue';
import VueStore from '@/store';
import { computed, defineComponent, ref, } from '@vue/composition-api';
import { useClient, useMobileView } from '@/composables';
import { mdiChevronLeft, mdiHomeOutline } from '@mdi/js';
import WithSideNavigations from '@/layouts/WithSideNavigations.vue';
import ClientBrands from '@/views/Dashboard/Clients/Components/ClientBrands.vue';
const BRAND_TABS = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
};
export default defineComponent({
    name: 'ClientDetails',
    components: {
        ClientBrands,
        Icon,
        ClientsBrandsSidebar,
        FilterToggler,
        ImageView,
        WithSideNavigations,
        SlotTabs,
    },
    async beforeRouteEnter(to, from, next) {
        const promises = [
            VueStore.dispatch('client/fetchClientDetails', to.params['id']),
        ];
        if (VueStore.getters['user/hasAdminRights']) {
            promises.push(VueStore.dispatch('attachment/fetchAttachments', {
                id: to.params['id'],
                target: 'organizations',
                type: 'document',
            }));
        }
        await Promise.all(promises);
        next();
    },
    setup(_, ctx) {
        const { client } = useClient();
        const { isMobileView } = useMobileView();
        const sidebarOpen = ref(false);
        const activeTab = ref(BRAND_TABS.ACTIVE);
        const tabs = computed(() => ({
            [BRAND_TABS.ACTIVE]: {
                name: BRAND_TABS.ACTIVE,
                label: ctx.root.$t('client-details-view.active'),
            },
            [BRAND_TABS.ARCHIVED]: {
                name: BRAND_TABS.ARCHIVED,
                label: ctx.root.$t('client-details-view.archived'),
            },
        }));
        const selectTab = (tab) => {
            activeTab.value = tab.name;
        };
        return {
            IconSize,
            mdiChevronLeft,
            mdiHomeOutline,
            ImageSize,
            client,
            sidebarOpen,
            isMobileView,
            activeTab,
            tabs,
            selectTab,
            BRAND_TABS,
        };
    },
});
